import { Trace } from '@abiglobalhealth/go-types'

export const formatTrace = (moduleId: string, stepId?: string, traces?: Trace[]): Trace => {
  if (stepId) {
    return {
      moduleId,
      stepId,
      isFirstOfModule: traces ? traces[traces.length - 1]?.moduleId !== moduleId : true
    }
  }

  return {
    moduleId
  }
}
